import { SyncableDictionary } from '@common/types/SyncableDictionary';
import { isArray, isObject } from 'lodash';

export class ListUtility {
  /**
   *
   * @param lst List of strings that need to be
   * @param conjunction
   * @param ifEmpty
   * @returns
   */
  static toOxford(
    list: string[],
    conjunction: 'and' | 'or' = 'and',
    delimiter: string = ', ',
    ifEmpty: string = '',
  ): string {
    // Copy list to Array
    const array = [...list];
    if (!Array.isArray(array) || array.length === 0) return ifEmpty;

    if (array.length === 1) return array[0];

    if (array.length === 2) return `${array[0]} ${conjunction} ${array[1]}`;

    const lastItem = array.pop();
    return `${array.join(`${delimiter}`)}${delimiter}${conjunction ? `${conjunction} ` : ''}${lastItem}`;
  }

  /**
   * Creates a Array of key-value of an array
   * @param enumme Any enum
   * @returns an array of key-value
   */
  static enumToArray(enumme: any): { key: number; value: string }[] {
    /** https://stackoverflow.com/a/43101184 */
    let map: { key: number; value: string }[] = [];

    for (var n in enumme) {
      if (typeof enumme[n] === 'number') {
        map.push({ key: <any>enumme[n], value: n });
      }
    }

    return map;
  }

  static reduceEnumToListValue(enumme: any) {
    const StringIsNumber = (val: any) => isNaN(Number(val)) === false;

    return Object.keys(enumme)
      .filter(StringIsNumber)
      .map((key) => enumme[key]);
  }
}

interface SyncableArray {
  __modelSyncSetName: string;
  items: Array<any>;
}

export class ObjectMetadataManager {

    /**
     * This function post-processes deserialized API responses.
     * + convert all 'null' to 'undefined'
     * + flatten all model sync set to their constituent items. Viz:
     * 
     *   Before: `foo: { __modelSyncSetName: string, items: Array<T> }`  
     *   After:  `foo: Array<T>`
     */
        static processApiResponseData<T>(obj: any): T {

        var syncableDictionary: SyncableDictionary = {};
        function process(target: any, key?: any) {
            if (target === null) {
                return undefined;
            }

      if (!isObject(target)) return target;

      const syncArray: SyncableArray = target as SyncableArray;

            if (syncArray.__modelSyncSetName && isArray(syncArray.items)) {
                syncableDictionary[syncArray.__modelSyncSetName] = key;
                target = syncArray.items;
            }

      for (const key in target) {
        if (!Object.prototype.hasOwnProperty.call(target, key)) {
          continue;
        }

                target[key] = process(target[key], key);
            }


            return target;
        }

        let rObj = process(obj);
        if (syncableDictionary && Object.keys(syncableDictionary).length > 0) {
            rObj.syncableProps = syncableDictionary;
        }
        let returnObj: T = rObj;

        return returnObj;
    }
}
